import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplicationErrorComponent } from './core/application-error/application-error.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './store/root.reducer';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { ErrorInterceptorProvider } from './services/error-interceptorv2.interceptor';
import { ApiinterceptorProvider } from './services/helpers/apiinterceptor.interceptor';
import { SessionService } from './services/session.service';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ignoreHtmlSanifications } from 'src/app/pipe/ignore-html-sanifications.pipe';
import { StatusbarModule } from './core/statusbar/statusbar.module';
import { LoadingAnimationModule } from "./core/loading-animation/loading-animation.module";
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// Register the locale data for Italy
registerLocaleData(localeIt, 'it');

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

/*export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.MicrosoftLoginData.clientId,
      authority: environment.MicrosoftLoginData.tenantId,
      redirectUri: 'https://192.168.114.49:4200',
      postLogoutRedirectUri: 'https://192.168.114.49:4200',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://login.microsoftonline.com', ['Scopes.Read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...'Scopes.Read']
    },
    loginFailedRoute: '/auth/login'
  };
}*/

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  declarations: [
    AppComponent,
    ApplicationErrorComponent,
    //ignoreHtmlSanifications,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StatusbarModule,
    StoreModule.forRoot(rootReducer),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
    ServiceWorkerModule.register('ngsw-worker.js', {
      // enabled: !isDevMode(),
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      //registrationStrategy: 'registerWhenStable:30000'
    }), 
    LoadingAnimationModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.MicrosoftLoginData.clientId,
          //authority: `https://login.microsoftonline.com/${environment.MicrosoftLoginData.tenantId}`,
          authority: `https://login.microsoftonline.com/common`,
          redirectUri: environment.MicrosoftLoginData.redirectUri,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Popup,
        authRequest: {
          scopes: environment.MicrosoftLoginData.apiSecretPermissionArray,
        },
      },
      {
        interactionType: InteractionType.Popup, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          [environment.MicrosoftLoginData.apiSecret, environment.MicrosoftLoginData.apiSecretPermissionArray],
        ]),
      }
    ),
  ], 
    
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    {
      provide: LOCALE_ID,
      deps: [SessionService],
      useFactory: (sessionService: SessionService) => sessionService.locale,
    },
    ErrorInterceptorProvider,
    ApiinterceptorProvider,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,
    { provide: LOCALE_ID, useValue: 'it' },
    provideAnimationsAsync(),
    /*{
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },*/
    /*{
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },*/
    /*{
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },*/
    /*MsalService,
    MsalBroadcastService,*/
  ],

})

export class AppModule {
  constructor(translate: TranslateService) {
    translate.addLangs(['en', 'it']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang!.match(/fr|it/) ? browserLang! : 'it')
  }
}
export function httpTranslateLoader(httpClient: HttpClient) {
  const baseHRef = environment.baseHREF;

  return new TranslateHttpLoader(httpClient, `${baseHRef}assets/i18n/`, '.json');
}

